module.exports = __webpack_public_path__ + "img/info-circle-svgrepo-com.932b1f40.svg";